import { useQuery } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import {
  buildMappableParams,
  initialMappableFilter,
} from '../lib/mappable-params';
import { catalogMappingKeys } from '../lib/query-keys';

/* One row is enough: the count is the page's total_data. */
const params = buildMappableParams('unmapped', {
  ...initialMappableFilter(''),
  limit: 1,
});

/*
 * How many listings of the account are unmapped, the same total the Unmatched
 * tab shows. Undefined while it loads or when it failed. The key sits inside
 * mappableLists(), so saving a mapping refreshes it.
 */
export function useUnmappedCount(enabled = true): number | undefined {
  const query = useQuery({
    queryKey: catalogMappingKeys.unmappedCount(),
    queryFn: () => CatalogService.getMappableListings(params),
    select: page => page.total_data,
    enabled,
  });

  return query.isError ? undefined : query.data;
}
